import { render, staticRenderFns } from "./ModernCalendar.vue?vue&type=template&id=9a5ba308&scoped=true"
import script from "./ModernCalendar.vue?vue&type=script&lang=js"
export * from "./ModernCalendar.vue?vue&type=script&lang=js"
import style0 from "./ModernCalendar.vue?vue&type=style&index=0&id=9a5ba308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5ba308",
  null
  
)

export default component.exports